// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CW-uA","roundLogo":"styles_roundLogo__7XCyI","communityLogo":"styles_communityLogo__b5KkO","authenticationLayout":"styles_authenticationLayout__cthQr"};